<!-- MasterBook.comment -->
<template>
  <div class="detail-text" v-html="newlineConvert(comment)" />
</template>

<script>
export default {
  name: "MbCommentDisp",
  props: {
    comment: {
      type: String,
      required: false,
      default: null,
    },
  },
};
</script>

<style lang="scss">
.detail-text {
  margin: 15px 0;
  font-size: 15px;
  line-height: 24px;
}
</style>
